import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import Slider from '@blocks/Slider'
import useStatic from '@hooks/useStatic'
import { RootState } from '@shared/redux/store'
import { colors } from '@styles/vars'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Stars from '../blocks/Stars'
import { voteNomination } from '../pages/SalonNominations/redux/nominations.slice'

export default function NominationSlider({ item: nomination, gallery }: Props) {
    const dispatch = useDispatch()
    const tempVotes = useSelector<RootState, RootState["nominations"]["tempVotes"]>(state => state.nominations.tempVotes)

    const castVote = async (score: number) => {
        dispatch(voteNomination({ id: nomination.id, score }))
    }

    const keyListener = useCallback((e: KeyboardEvent) => {
        const isDigit = e.key >= "0" && e.key <= "9"

        if (!isDigit) 
            return

        switch (e.key) {
            case "0":
                castVote(10)
                break
            default:
                castVote(parseInt(e.key))
        }
    }, [nomination])

    useEffect(() => {
        document.addEventListener("keydown", keyListener)
        return () => document.removeEventListener("keydown", keyListener)
    }, [keyListener])
    
    return (
        <Slider src={nomination.photo.url} gallery={gallery}>
            <Content>
                <Grid gap="15px">
                    <Grid gap="5px">
                        <h3>{nomination.photo.title}</h3>
                        <Original>Original: <a href={nomination.photo.url} target="_blank">{nomination.photo.width}x{nomination.photo.height}</a></Original>
                    </Grid>
                    <StarsWrapper><Stars score={tempVotes[nomination.id] || nomination.vote?.score} cast={castVote} border="transparent" /></StarsWrapper>
                </Grid>
            </Content>
        </Slider>
    )
}

interface Props {
    item: Jury.Resources.Nomination
    gallery: Interfaces.Gallery
}

// STYLES
const Original = styled.small`
    opacity: .8;
`

const StarsWrapper = styled.div`
    max-width: 400px;
`

const Content = styled.div`
    h4, a, small, button, p {
        color: ${colors.white};
    }

    svg {
        fill: ${colors.white};
    }
`